import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type {
  PettyCashFloatListDto,
  PettyCashFloatDetailDto,
  CreatePettyCashFloatCommand,
  FundingMovementRequest,
  PaymentMovementRequest,
} from '@/types/pettyCash.types';

export const pettyCashApi = {
  /** GET /api/v1/petty-cash/floats — the float register */
  /**
   * @param atLocationId Narrows the list to floats reachable from that location — the ones held
   * there plus any float with no location, which is company-wide. Omit it to list every float in
   * the company, which is what the maintenance screen wants.
   */
  list: (status?: string, atLocationId?: string) =>
    apiClient.get<ApiResponse<PettyCashFloatListDto[]>>('/petty-cash/floats', {
      params: { status, atLocationId },
    }),

  /** GET /api/v1/petty-cash/floats/{id} — a float and its movement statement */
  get: (id: string) =>
    apiClient.get<ApiResponse<PettyCashFloatDetailDto>>(`/petty-cash/floats/${id}`),

  /** POST /api/v1/petty-cash/floats */
  create: (command: CreatePettyCashFloatCommand) =>
    apiClient.post<ApiResponse<{ id: string }>>('/petty-cash/floats', command),

  /** POST /api/v1/petty-cash/floats/{id}/top-up — cash in */
  topUp: (id: string, body: FundingMovementRequest) =>
    apiClient.post<ApiResponse<void>>(`/petty-cash/floats/${id}/top-up`, body),

  /** POST /api/v1/petty-cash/floats/{id}/pay — cash out to an expense */
  pay: (id: string, body: PaymentMovementRequest) =>
    apiClient.post<ApiResponse<void>>(`/petty-cash/floats/${id}/pay`, body),

  /** POST /api/v1/petty-cash/floats/{id}/return — cash back to a bank/cash account */
  returnToBank: (id: string, body: FundingMovementRequest) =>
    apiClient.post<ApiResponse<void>>(`/petty-cash/floats/${id}/return`, body),

  /** POST /api/v1/petty-cash/floats/{id}/close */
  close: (id: string) =>
    apiClient.post<ApiResponse<void>>(`/petty-cash/floats/${id}/close`),
};
